<template>
  <div ref="container">
    <slot v-if="created"></slot>
  </div>
</template>

<script>

  import loadjs from 'loadjs'
  import {createObjectByEval} from '@/utils/commonUtils'


  export default {
    name: "vue-cesium",
    props: {
      name: {
        type: String,
        default: 'default'
      },
      options: {
        type: Object,
        default: () => {
          return {
            baseLayerPicker: false,
            homeButton: false,
            navigationHelpButton: false,
            fullscreenButton: false,
            infoBox: false,
            timeLine: false,
            shouldAnimate: true,
            imageryProvider: Cesium.createTileMapServiceImageryProvider({
              url: Cesium.buildModuleUrl('Assets/Textures/NaturalEarthII')
            }),
          }
        }
      }
    },

    data() {
      return {
        created: false
      }
    },

    mounted() {
      window.CESIUM_BASE_URL = "/static/Cesium";
      const self = this;
      if (!loadjs.isDefined('cesium')) loadjs(['/static/Cesium/Cesium.js', '/static/Cesium/Widgets/widgets.css'], 'cesium', function () {
        self.init();
      }); else self.init();
    },

    methods: {
      init() {
        //Tips! Ограничивем компиляуию option в vue-json-layout через options$ т.к. в нем могут быть
        //использованы выражения с объект Cesium, который может быть еще не загружен
        //Компилируем options после загрузки
        const options = createObjectByEval(this.options, {})

        const viewer = new window.Cesium.Viewer(this.$refs.container, options);


        var camera = viewer.camera;
        camera.constrainedAxis = Cesium.Cartesian3.UNIT_Z;


        if (!window.cesiumViewer) window.cesiumViewer = {};

        window.cesiumViewer[this.name] = new CesiumObject(viewer);

        hideElement(viewer._toolbar);
        hideElement(viewer._bottomContainer);

        if (!this.options.timeLine) {
          hideElement(viewer._timeline.container);
          hideElement(viewer._animation.container);
        }

        viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(window.Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(window.Cesium.ScreenSpaceEventType.LEFT_CLICK);
        viewer.scene.globe.enableLighting = true;

        this.created = true;

        function hideElement(e) {
          e.style.visibility = 'hidden';
        }

        function CesiumObject(viewer) {
          this.viewer = viewer;

          this._czmlDataSources = new Map();

          this.getCzmlDataSource = function (name) {

            if (this._czmlDataSources.has(name)) {
              return (this._czmlDataSources.get(name));
            }
            else {
              const czmlDataSource = createCzmlDataSource();
              this.viewer.dataSources.add(czmlDataSource);
              this._czmlDataSources.set(name, czmlDataSource);
              return czmlDataSource;
            }

            function createCzmlDataSource() {
              const czmlDataSource = new Cesium.CzmlDataSource();

              czmlDataSource.process([{
                id: "document",
                name: "simple",
                version: "1.0"
              }], {});

              return czmlDataSource;
            }
          }
        }
      }
    }
  }
</script>

<style>
  .cesium-widget canvas {
    image-rendering: auto !important;
  }
</style>
